import { render } from "./Union.svg?vue&type=template&id=00502824"
const script = {}
script.render = render

export default script